import React from 'react';
import { motion } from 'framer-motion';
import { Home, User, Settings, Shield } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAuth();

  const navItems = [
    { id: 'home', path: '/', icon: Home, label: 'Home' },
    { id: 'profile', path: '/profile', icon: User, label: 'Profile' },
    { id: 'settings', path: '/settings', icon: Settings, label: 'Settings' },
  ];

  if (isAdmin) {
    navItems.push({ id: 'admin', path: '/admin', icon: Shield, label: 'Admin' });
  }

  const activeIndex = navItems.findIndex(item => location.pathname === item.path);

  return (
    <motion.div
      className="fixed bottom-0 left-0 right-0 pb-4 sm:pb-6 pt-3 sm:pt-4 z-50"
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ delay: 0.5, type: 'spring', stiffness: 200 }}
    >
      <div className="max-w-md mx-auto px-4 sm:px-6">
        <div className="relative bg-gray-800/40 backdrop-blur-2xl rounded-[24px] sm:rounded-[28px] shadow-2xl border border-gray-700/50 p-1.5 sm:p-2">
          <div className="flex items-center justify-around relative">
            <motion.div
              className="absolute bg-gradient-to-br from-cyan-500 to-blue-600 rounded-[20px] sm:rounded-[22px] shadow-lg"
              style={{
                width: `${100 / navItems.length}%`,
                height: 'calc(100% - 6px)',
                top: '3px',
              }}
              initial={false}
              animate={{
                left: `calc(${(activeIndex * 100) / navItems.length}% + 3px)`,
              }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 30,
              }}
            />

            {navItems.map((item, idx) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;

              return (
                <motion.button
                  key={item.id}
                  onClick={() => navigate(item.path)}
                  className="relative z-10 flex items-center justify-center py-3 sm:py-4 flex-1"
                  whileTap={{ scale: 0.95 }}
                >
                  <Icon
                    size={20}
                    className={`${isActive ? 'text-white' : 'text-gray-400'} sm:w-6 sm:h-6`}
                    strokeWidth={isActive ? 2.5 : 2}
                  />
                </motion.button>
              );
            })}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default BottomNav;
